import React from 'react'
import { BreadcrumbsItem } from 'react-breadcrumbs-dynamic'
import { Routes, Route } from 'react-router-dom'
import { AuthenticatedRoute } from '../../shared/routing/AuthenticatedRoute'
import { useOfferionTranslation } from '../../shared/store/hooks/useOfferionTranslation'
import { AgreedPricesContainer } from './agreed-prices/AgreedPricesListContainer'
import { ClientsListContainer } from './list/ClientsListContainer'

export const ClientsContainer = () => {
    const { t } = useOfferionTranslation()

    return (
        <>
            <BreadcrumbsItem to="/clients">{t('Clients.Header.pageTitle')}</BreadcrumbsItem>

            <Routes>
                <Route path="/" element={<AuthenticatedRoute element={<ClientsListContainer />} />} />
                <Route path="/:clientId/agreed-prices" element={<AuthenticatedRoute element={<AgreedPricesContainer />} />} />
            </Routes>
        </>
    )
}
